// STYLES VENDORS
// import 'animate.css'
// import 'material-design-iconic-font/dist/css/material-design-iconic-font.css'
import "ui-select/dist/select.css";

// JQUERY AND PLUGINS
// import $ from 'jquery'
// import 'jquery-ui'
// import 'jquery.browser'

// BOOTSTRAP
import "bootstrap";
import "jasny-bootstrap/dist/js/jasny-bootstrap";
import "bootstrap-notify";

// TINYMCE
import "tinymce";
import "tinymce/themes/inlite/theme.min.js";
import "tinymce/plugins/advlist/plugin.min.js";
import "tinymce/plugins/anchor/plugin.min.js";
import "tinymce/plugins/autolink/plugin.min.js";
import "tinymce/plugins/autoresize/plugin.min.js";
import "tinymce/plugins/autosave/plugin.min.js";
import "tinymce/plugins/bbcode/plugin.min.js";
import "tinymce/plugins/charmap/plugin.min.js";
import "tinymce/plugins/code/plugin.min.js";
import "tinymce/plugins/codesample/plugin.min.js";
import "tinymce/plugins/colorpicker/plugin.min.js";
import "tinymce/plugins/contextmenu/plugin.min.js";
import "tinymce/plugins/directionality/plugin.min.js";
import "tinymce/plugins/emoticons/plugin.min.js";
import "tinymce/plugins/fullpage/plugin.min.js";
import "tinymce/plugins/hr/plugin.min.js";
import "tinymce/plugins/image/plugin.min.js";
import "tinymce/plugins/imagetools/plugin.min.js";
import "tinymce/plugins/importcss/plugin.min.js";
import "tinymce/plugins/insertdatetime/plugin.min.js";
import "tinymce/plugins/legacyoutput/plugin.min.js";
import "tinymce/plugins/link/plugin.min.js";
import "tinymce/plugins/lists/plugin.min.js";
import "tinymce/plugins/media/plugin.min.js";
import "tinymce/plugins/nonbreaking/plugin.min.js";
import "tinymce/plugins/noneditable/plugin.min.js";
import "tinymce/plugins/pagebreak/plugin.min.js";
import "tinymce/plugins/paste/plugin.min.js";
import "tinymce/plugins/preview/plugin.min.js";
import "tinymce/plugins/print/plugin.min.js";
import "tinymce/plugins/save/plugin.min.js";
import "tinymce/plugins/searchreplace/plugin.min.js";
import "tinymce/plugins/spellchecker/plugin.min.js";
import "tinymce/plugins/tabfocus/plugin.min.js";
import "tinymce/plugins/table/plugin.min.js";
import "tinymce/plugins/template/plugin.min.js";
import "tinymce/plugins/textcolor/plugin.min.js";
import "tinymce/plugins/textpattern/plugin.min.js";
import "tinymce/plugins/toc/plugin.min.js";
import "tinymce/plugins/visualblocks/plugin.min.js";
import "tinymce/plugins/visualchars/plugin.min.js";
import "tinymce/plugins/wordcount/plugin.min.js";

// VENDORS
import "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import "offline-js";
import "offline-js/themes/offline-theme-default.css";
import "offline-js/themes/offline-language-spanish.css";
import "select2";
import "select2/select2.css";
import "select2-bootstrap-css/select2-bootstrap.css";

// STYLES
import "./style/app.less";

// APP
import "./angular";

// POLYFILL
if (!global.Intl) {
  require.ensure(["intl", "intl/locale-data/complete.js"], function(require) {
    require("intl");
    require("intl/locale-data/complete.js");
  });
}
